import { environment } from "src/environments/environment";


export class FileHelper {

  static humanFileSize(bytes: number) {
    const thresh = 1024;

    if (Math.abs(bytes) < thresh) {
      return bytes + ' B';
    }
    const units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    let u = -1;
    do {
      bytes /= thresh;
      ++u;
    } while (Math.abs(bytes) >= thresh && u < units.length - 1);
    return bytes.toFixed(1) + ' ' + units[u];

  }



  static getMimeTypeInfo(mimeType: string) {
    const res = {
      type: 'documento',
      ext: mimeType,
    }
    const ext = mimeType.includes('/') ? mimeType.split('/')[1] : mimeType;

    switch (ext) {
      case 'png':
      case 'jpeg':
      case 'jpg':
      case 'gif':
      case 'bmp':
      case 'webp':
        res.type = 'imagem';
        res.ext = ext;
        break;
      case 'svg+xml':
        res.type = 'imagem';
        res.ext = 'svg';
        break;
      case 'pdf':
        res.type = 'documento';
        res.ext = ext;
        break;
      case 'vnd.openxmlformats-officedocument.wordprocessingml.document':
        res.type = 'documento';
        res.ext = 'docx';
        break;
      case 'vnd.openxmlformats-officedocument.spreadsheetml.sheet':
        res.type = 'documento';
        res.ext = 'xlsx';
        break;
      case 'vnd.openxmlformats-officedocument.presentationml.presentation':
        res.type = 'documento';
        res.ext = 'pptx';
        break;
      case 'vnd.ms-excel':
        res.type = 'documento';
        res.ext = 'xls';
        break;
      case 'vnd.ms-powerpoint':
        res.type = 'documento';
        res.ext = 'ppt';
        break;
      case 'vnd.openxmlformats-officedocument.presentationml.slideshow':
        res.type = 'documento';
        res.ext = 'ppsx';
        break;
      case 'vnd.openxmlformats-officedocument.presentationml.template':
        res.type = 'documento';
        res.ext = 'potx';
        break;
      case 'vnd.openxmlformats-officedocument.spreadsheetml.template':
        res.type = 'documento';
        res.ext = 'xltx';
        break;
      case 'vnd.openxmlformats-officedocument.wordprocessingml.template':
        res.type = 'documento';
        res.ext = 'dotx';
        break;
      case 'vnd.ms-word.document.macroEnabled.12':
        res.type = 'documento';
        res.ext = 'docm';
        break;
      case 'vnd.ms-word.template.macroEnabled.12':
        res.type = 'documento';
        res.ext = 'dotm';
        break;
      case 'vnd.ms-excel.sheet.macroEnabled.12':
        res.type = 'documento';
        res.ext = 'xlsm';
        break;
      case 'vnd.ms-excel.template.macroEnabled.12':
        res.type = 'documento';
        res.ext = 'xltm';
        break;
      case 'vnd.ms-powerpoint.template.macroEnabled.12':
        res.type = 'documento';
        res.ext = 'potm';
        break;
      case 'vnd.ms-powerpoint.slideshow.macroEnabled.12':
        res.type = 'documento';
        res.ext = 'ppsx';
        break;
      case 'vnd.ms-powerpoint.presentation.macroEnabled.12':
        res.type = 'documento';
        res.ext = 'pptm';
        break;
      case 'vnd.openxmlformats-officedocument.presentationml.slide':
        res.type = 'documento';
        res.ext = 'sldx';

        break;
      default:
        res.type = 'documento';
        res.ext = ext;
        break;
    }
    return res;
  }

  static getImagePublicURL(photo_url: string) {

    if (!photo_url) {
      return null;
    }

    const basePath = environment.firebase.publicImagePath;
    const path = basePath + photo_url.split('/').join('%2F') + '?alt=media';
    return path;
  }

}
